import { UnitCodesState } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const unitCodesSelector = (state: RootState): UnitCodesState => state.unitCodes;

export const selectAllUnitCodes = createSelector([unitCodesSelector], unitCodes => unitCodes.unitCodes);
